import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, Facebook, Twitter, Linkedin, Youtube, Instagram } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="w-full">
      {/* Top Support Bar */}
      <div className="bg-[#168039] text-white py-3">
        <div className="container mx-auto px-4 flex flex-col md:flex-row justify-between items-center gap-4">

          {/* Left Side: Contact Info */}
          <div className="flex flex-col md:flex-row items-center gap-4 md:gap-8">
            <span className="font-bold text-lg">Need support?</span>

            <div className="flex items-center gap-2">
              <span className="bg-white rounded-full p-1">
                <Phone size={14} className="text-[#168039]" />
              </span>
              <a href="tel:+919116684439" className="hover:text-green-100 transition-colors bg-transparent border-none p-0">
                +91 91166 84439
              </a>
            </div>

            <div className="flex items-center gap-2">
              <span className="bg-white rounded-full p-1">
                <Mail size={14} className="text-[#168039]" />
              </span>
              <a href="mailto:support@taxberg.com" className="hover:text-green-100 transition-colors bg-transparent border-none p-0">
                support@taxberg.com
              </a>
            </div>
          </div>

          {/* Right Side: Social Icons */}
          <div className="flex items-center gap-4">
            <a href="#" className="hover:text-green-200 transition-colors"><Facebook size={20} /></a>
            <a href="#" className="hover:text-green-200 transition-colors"><Twitter size={20} /></a>
            <a href="#" className="hover:text-green-200 transition-colors"><Linkedin size={20} /></a>
            <a href="#" className="hover:text-green-200 transition-colors"><Youtube size={20} /></a>
            <a href="#" className="hover:text-green-200 transition-colors"><Instagram size={20} /></a>
          </div>

        </div>
      </div>

      {/* Main Footer Content */}
      <div className="bg-gray-800 text-white">
        <div className="container mx-auto px-4 py-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div>
              <Link to="/" className="hover:opacity-90 transition-opacity block mb-4">
                <img
                  src="/images/icon/logo.png"
                  className="img-fluid w-[100px] rounded-top"
                  alt="TaxBerg Logo"
                />
              </Link>
              <p className="text-gray-400">
                Your trusted partner for all tax-related services.
              </p>
            </div>
            <div>
              <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
              <ul className="space-y-2">
                <li>
                  <Link to="/" className="text-gray-400 hover:text-white transition-colors">
                    Home
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-gray-400 hover:text-white transition-colors">
                    About
                  </Link>
                </li>
                <li>
                  <Link to="/services" className="text-gray-400 hover:text-white transition-colors">
                    Services
                  </Link>
                </li>
                <li>
                  <Link to="/contact" className="text-gray-400 hover:text-white transition-colors">
                    Contact
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="text-lg font-semibold mb-4">Contact Info</h4>
              <ul className="space-y-2 text-gray-400">
                <li>Email: <a href="mailto:naveen@taxberg.com" className="hover:text-white">naveen@taxberg.com</a></li>
                <li>Phone: <a href="tel:+919958802926" className="hover:text-white">+91 9958802926</a></li>
                <li>Address: Noida Section 62</li>
              </ul>
            </div>
          </div>
          <div className="border-t border-gray-700 mt-8 pt-6 text-center text-gray-400">
            <p>&copy; {new Date().getFullYear()} TaxBerg. All rights reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
